import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Achievements } from "./components/Achievements";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { useEffect } from "react";
function App() {
  useEffect(() => {
   
    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname);
    }

    
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Achievements />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;



